(() => {
  const initProtocolSteps = (sectionElement = null) => {
    const rootElement = sectionElement || document;
    const steps = rootElement.querySelectorAll('.am-protocol__step');

    steps.forEach((step) => {
      if (step.hasAttribute('data-initialized')) return;
      
      const header = step.querySelector('.am-protocol__step-header');
      const content = step.querySelector('.am-protocol__step-content');
      const iconElement = step.querySelector('.am-protocol__toggle-icon');

      if (!header || !content || !iconElement) return;

      step.setAttribute('data-initialized', 'true');
      step.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0';
      content.style.opacity = '0';

      const isDefaultOpen = step.classList.contains('am-protocol__step--open');
      if (isDefaultOpen) {
        step.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.opacity = '1';
        step.classList.add('is-expanded');
        header.setAttribute('aria-label', 'Collapse step details');
        iconElement.classList.add('is-rotated');
      }

      header.style.cursor = 'pointer';
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');

      const closeAllOtherSteps = () => {
        const currentSection = step.closest('.am-protocol');
        if (!currentSection) return;

        currentSection.querySelectorAll('.am-protocol__step').forEach((otherStep) => {
          if (otherStep !== step && otherStep.getAttribute('aria-expanded') === 'true') {
            const otherHeader = otherStep.querySelector('.am-protocol__step-header');
            const otherContent = otherStep.querySelector('.am-protocol__step-content');
            const otherIconElement = otherStep.querySelector('.am-protocol__toggle-icon');

            otherStep.setAttribute('aria-expanded', 'false');
            otherStep.classList.remove('is-expanded');
            
            if (otherHeader) otherHeader.setAttribute('aria-label', 'Expand step details');
            if (otherContent) {
              otherContent.style.maxHeight = '0';
              otherContent.style.opacity = '0';
            }
            if (otherIconElement) otherIconElement.classList.remove('is-rotated');
          }
        });
      };

      const toggleStep = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = step.getAttribute('aria-expanded') === 'true';

        if (!isExpanded) closeAllOtherSteps();

        step.setAttribute('aria-expanded', !isExpanded);
        header.setAttribute('aria-label', isExpanded ? 'Expand step details' : 'Collapse step details');

        if (isExpanded) {
          content.style.maxHeight = '0';
          content.style.opacity = '0';
          step.classList.remove('is-expanded');
          iconElement.classList.remove('is-rotated');
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.opacity = '1';
          step.classList.add('is-expanded');
          iconElement.classList.add('is-rotated');
        }
      };

      header.addEventListener('click', toggleStep);
    });
  };

  const init = () => {
    initProtocolSteps();
    setTimeout(initProtocolSteps, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.am-protocol');
    if (section) setTimeout(() => initProtocolSteps(section), 100);
  });
})();